import React, {Component} from 'react';
import {Input, Icon, AutoComplete} from 'antd';
import './index.css';

const Option = AutoComplete.Option;

export default class HeaderSearch extends Component {
  state = {
    searchMode: false,
    value: '',
  };

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  onSelect = (value, option) => {
    if (this.props.onSelect) {
      this.props.onSelect(value);
    }
  };

  enterSearchMode = () => {
    this.setState({searchMode: true}, () => {
      if (this.state.searchMode) {
        this.input.focus();
      }
    });
  };

  leaveSearchMode = () => {
    this.setState({
      searchMode: false,
      value: '',
    });
  };

  filterFunction = (inputValue, option) => {
    return inputValue && inputValue.length && option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
  };

  render() {
    const {placeholder, ...restProps} = this.props;
    const inputClass = this.state.searchMode ? 'input show' : 'input';

    const options = this.props.data.map((locale) => {
      return <Option key={locale.f} value={String(locale.f)} style={{fontWeight: locale.t === 's' ? 'bold' : 'normal'}}>{locale.n}</Option>
    });

    return (
      <div
        className="headerSearch"
        onClick={this.enterSearchMode}
      >
        <Icon type="search"/>
        <AutoComplete
          className={inputClass}
          onSelect={this.onSelect}
          dataSource={options}
          value={this.state.value}
          filterOption={this.filterFunction}
          defaultActiveFirstOption={false}
          {...restProps}
        >
          <Input
            placeholder={placeholder}
            ref={(node) => {
              this.input = node;
            }}
            onBlur={this.leaveSearchMode}
          />
        </AutoComplete>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/HeaderSearch/index.js